
export function HomePageImages() {

  const mains = document.querySelectorAll('.txt-img-line')
  mains.forEach(row => {
    // window resize performance optymalization
    const throttle = {
      'delay': 100,
      'wait': false,
    }
    // initial images
    row.querySelectorAll('.floating-images').length === 0 && CreateImagesContainers(row)
    SetImagesPositions(row)
    // fit images to widnow size
    window.addEventListener('resize', () => {
      if (!throttle.wait) {
        SetImagesPositions(row)
        throttle.wait = true
      } 
      setTimeout(() => {
        throttle.wait = false
      }, throttle.delay);    
    })
  });  
}

// set size and position of containers
function SetImagesPositions(row) {
  const rowBox = row.getBoundingClientRect()
  const txtBox = row.querySelector('.txt').getBoundingClientRect()
  const windowWidth = window.innerWidth
  const pos = {
    'top': rowBox.top,
    'bottom': rowBox.bottom,
    'height': rowBox.height,
    'txt': {
      'left': txtBox.left,
      'right': txtBox.right,
    },
    'offset' : {
      'left': rowBox.left,
      'right': rowBox.right
    }
  }
  const left = row.querySelector('.floating-images.left-part')
  const right = row.querySelector('.floating-images.right-part')

  // set left side
  const leftData = {
    'width': pos.txt.left - 200
  }
  left.style.left = `-${pos.offset.left}px`
  if (leftData.width > 0) {
    left.style.width = `${leftData.width}px`
  } else {
    left.style.width = '0px'
  }
  // set right side
  const rightData = {}
  rightData['left'] = pos.txt.right - pos.offset.left + 200
  rightData['width'] = windowWidth - ( rightData.left + pos.offset.left )
  right.style.left = `${rightData.left}px`
  if ( rightData.width > 0 ) {
    right.style.width = `${rightData.width}px`
  } else {
    right.style.width = '0px'
  }
}

// Create floating images containers
function CreateImagesContainers(row) {
  const el = document.createElement('div')
  el.classList.add('floating-images')
  const leftPart = el.cloneNode(true)
  const rightPart = el.cloneNode(true)

  leftPart.classList.add('left-part')
  rightPart.classList.add('right-part')

  row.innerHTML += leftPart.outerHTML
  row.innerHTML += rightPart.outerHTML  
}